import {
  Box,
  Button,
  Checkbox,
  Flex,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { flexRender, getCoreRowModel, getSortedRowModel, useReactTable, createColumnHelper } from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import isEmpty from 'lodash/isEmpty';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'components/Toast';
import { useUserState } from 'context/UserContext';
import { useDelSocialListMutation, useUpdateSocialMutation } from 'services/social';
import AuthorizationComponentWrapper from 'components/AuthorizationComponentWrapper/AuthorizationComponentWrapper';
import { ModalType } from 'constants/common';

const SizeTable = ({ socialTable, handleUpdateSocial, refetch }) => {
  const [sorting, setSorting] = useState([]);
  const [rowSelection, setRowSelection] = useState([]);
  const deleteLinkMutation = useDelSocialListMutation();
  const changeSocialStatusMutation = useUpdateSocialMutation();
  const { userInfo } = useUserState();

  const handleRowClick = (shortlink, type) => {
    handleUpdateSocial(shortlink, type);
  };

  const handleDeleteSocial = async socialDetail => {
    const confirmDelete = window.confirm('Bạn có chắc chắn muốn xóa đường dẫn này không?');
    if (!confirmDelete) {
      return;
    }
    deleteLinkMutation.mutate(
      { socialId: socialDetail?._id },
      {
        onSuccess: () => {
          toast.showMessageSuccess('Xóa đường dẫn thành công');
          refetch?.();
        },
        onError: () => {
          toast.showMessageError('Xóa đường dẫn không thành công');
          refetch?.();
        },
      }
    );
  };

  const handleChangStatus = async socialDetail => {
    const confirm = window.confirm('Bạn có chắc chắn muốn thay đổi trạng thái này không?');
    if (!confirm) {
      return;
    }

    changeSocialStatusMutation.mutate(
      { socialId: socialDetail?._id },
      {
        onSuccess: () => {
          toast.showMessageSuccess('Thay đổi trạng thái thành công');
          refetch?.();
        },
        onError: () => {
          toast.showMessageError('Thay đổi trạng thái không thành công');
          refetch?.();
        },
      }
    );
  };

  const columnHelper = createColumnHelper();
  const onRowSelectionChange = newSelection => setRowSelection(newSelection);
  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: 'name',
        cell: info => <Text whiteSpace={'nowrap'}>{info.getValue()}</Text>,
      }),

      columnHelper.accessor('brandingId.name', {
        header: 'Branding',

        cell: info => <Text whiteSpace={'nowrap'}>{info.getValue()}</Text>,
      }),
  
      columnHelper.accessor('isActive', {
        header: 'Is Active',
        cell: info => <Switch isChecked={info.getValue()} onChange={() => handleChangStatus(info?.row?.original)}></Switch>,
      }),

      columnHelper.accessor('action', {
        header: 'Thao tác',
        cell: info => (
          <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'UPDATE_PRODUCT_CATEGORY'}>
            <Flex alignItems="center" gap={1}>
              <IconButton
                bg="transparent"
                onClick={() => {
                  handleRowClick(info?.row?.original, ModalType.Add);
                }}
              >
                <EditIcon cursor="pointer" boxSize={4} />
              </IconButton>
              {/* <IconButton
              bg="transparent"
              onClick={() => {
                history.push(`/admin/category/${info?.row?.original?._id}/size`);
                }}
                >
              <TbTextResize size={16} />
              </IconButton>
              <IconButton
              bg="transparent"
              onClick={() => {
                history.push(`/admin/category/${info?.row?.original?._id}/colors`);
                }}
                >
                <MdOutlineColorLens size={16} />
                </IconButton> */}
              <IconButton
                bg="transparent"
                onClick={() => {
                  handleDeleteSocial(info?.row?.original);
                }}
              >
                <DeleteIcon color="red.400" boxSize={4} />
              </IconButton>
            </Flex>
          </AuthorizationComponentWrapper>
        ),
      }),
    ],
    [socialTable]
  );

  var table = useReactTable({
    data: socialTable || [],
    columns,
    state: {
      sorting,
      rowSelection,
    },
    onSortingChange: setSorting,
    onRowSelectionChange,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
    enableRowSelection: true,
    getRowId: row => {
      return row._id;
    },
  });
  
  return (
    <>
      <Table>
        <Thead>
          {table.getHeaderGroups().map(headerGroup => (
            <Tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <Th key={header.id}>
                  {header.isPlaceholder ? null : (
                    <Box w={'fit-content'} cursor={header.column.getCanSort() ? 'pointer' : 'default'}>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {/* {{
                        asc: ' 🔼',
                        desc: ' 🔽',
                      }[header.column.getIsSorted()] ?? null} */}
                    </Box>
                  )}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {isEmpty(table.getRowModel().rows) ? (
            <Tr>
              <Td textAlign="center" colSpan={5}>
                Không có dữ liệu
              </Td>
            </Tr>
          ) : (
            table.getRowModel().rows.map(row => (
              <Tr key={row.id}>
                {row.getVisibleCells().map(cell => (
                  <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
                ))}
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </>
  );
};

export default SizeTable;
